import {
  useI18n,
  type UniversalCreateInstanceParams,
} from "@brightdotai/digital-water-i18n";
import { NAMESPACES as I18N_NAMESPACES } from "@brightdotai/digital-water-locale-config";

export const SUPPORTED_LOCALES: Array<string> = ["en-US"];
export const DEFAULT_LOCALE = "en-US";

// extra namespaces in portal
const USERS_NAMESPACE = "users";
const PORTAL_NAMESPACE = "portal";
const TEMPLATES_NAMESPACE = "templates";
const COMMENTS_NAMESPACE = "comments";

const TRANSLATION_FILES_PATH = "locales";
export const CREATE_I18N_ARGS: UniversalCreateInstanceParams = {
  path: TRANSLATION_FILES_PATH,
  // Todo: This should be loaded dynamically based on the route loaded
  // maybe something like implemented here https://github.com/sergiodxa/remix-i18next/blob/7ef6de56a2007429415a7d2fab65d32b64592465/src/client.ts#L10
  // but that requires we split up the translation files into route-based chunks?
  namespace: [
    USERS_NAMESPACE,
    PORTAL_NAMESPACE,
    TEMPLATES_NAMESPACE,
    COMMENTS_NAMESPACE,
    ...I18N_NAMESPACES,
  ],
  fallbackLocale: DEFAULT_LOCALE,
  supportedLocales: SUPPORTED_LOCALES,
};

export function useT(namespace?: string) {
  let { i18n } = useI18n();
  // TODO: This is a hack to load the namespace if it hasn't been loaded yet
  if (namespace) {
    if (!i18n.hasLoadedNamespace(namespace)) {
      i18n.loadNamespaces(namespace).catch(() => {
        // Failed to load translation namespace
      });
    }
  }
  return i18n.getFixedT(i18n.language, namespace);
}

export function getPreloadedNamespaces(): string[] {
  return CREATE_I18N_ARGS.namespace;
}
